import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Navigation from "../components/Navigation";
import Footer from "../components/Footer";
import ClubCard from "../components/club/Card";
import { getAllClub } from "../lib/actions";
import { toast } from "sonner";
import { LoaderIcon } from "../components/svg/Icons";

const Section = styled.section`
  min-height: ${(props) => `calc(100vh - ${props.theme.navHeight})`};
  width: 100vw;
  position: relative;
  background-color: ${(props) => props.theme.body};
`;

const Container = styled.div`
  width: 90%;
  min-height: 80vh;
  margin: 0 auto;
  margin-bottom: 2rem;

  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;

  @media (max-width: 64em) {
    width: 85%;
  }
  @media (max-width: 48em) {
    width: 100%;
  }
`;

const HeroWrapper = styled.section`
  padding: 4rem 0 2rem 0;
  margin: 0 auto;
  text-align: center;

  @media (max-width: 768px) {
    margin: 2rem
  }
`;

const GridRow2 = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1.5rem;
  margin-top: 2rem;

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr); /* 2 per row on tablets */
  }

  @media (max-width: 480px) {
    grid-template-columns: 1fr; /* stack on small phones */
  }
`;

// ========== Inline Components ==========1
const Hero = () => (
  <HeroWrapper>
    <h2>Welcome to the Clubs</h2>
    <p>Discover and participate in amazing communities.</p>
  </HeroWrapper>
);

// Updated Parent Component
const ConnectPage = () => {
  const [clubs, setClubs] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch clubs data
  useEffect(() => {
    const fetchClubs = async () => {
      try {
        setLoading(true);
        const allClubs = await getAllClub();
        console.log(allClubs)
        setClubs(allClubs);
      } catch (error) {
        console.error("Error fetching clubs:", error);
        toast.error("Failed to load clubs");
      } finally {
        setLoading(false);
      }
    };

    fetchClubs();
  }, []);

  return (
    <Section id="Login">
      <Navigation />
      <Container>
        <Hero />
        
        {loading ? (
          <div style={{ textAlign: 'center', padding: '2rem', margin: "auto" }}>
            <LoaderIcon width="40" />
            <p>Loading clubs...</p>
          </div>
        ) : (
          <>
            {/* <ClubGrid clubs={clubs} /> */}
            
            <GridRow2>
              {clubs.length > 0 ? (
                clubs.map((club, index) => (
                  <ClubCard key={club.$id || index} club={club} />
                ))
              ) : (
                <div style={{ textAlign: 'center', padding: '2rem', gridColumn: '1 / -1' }}>
                  <p>No clubs available at the moment.</p>
                </div>
              )}
            </GridRow2>
          </>
        )}

        {/* <GridRow>
          <SubmissionStatus />
          <ClubRules />
        </GridRow> */}
      </Container>
      <Footer />
    </Section>
  );
};
export default ConnectPage;
